<template>
    <modal :allow-cancel="false" custom-class="max-w-md" :contentMedium="true" @closed="$emit('closed')">
        <div>
            <h2 v-text="$t('ABOUT_DONATION')"/>
            <p  class="charityu" v-text="$t('FREDDIES_DONATION_CHARITY')"/>
            <p  class="charityu" v-text="$t('FREDDIES_CHARITY')"/>
        </div>
        <div class="charity--price--image img-container">
            <img src="@/assets/images/decoration/dementia-adventure.png">
            <img src="@/assets/images/decoration/pennies-price.png">
        </div>
        <p class="charityp" v-text="$t('FREDDIES_CHARITY_CANCEL')"></p>
    </modal>
</template>

<script>
import Modal from '@/components/structure/Modal';

export default {
    name: 'CharityTermsModal',

    components: {
        Modal,
    },
};
</script>

<style lang="scss" scoped>
.img-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.charityp {
    font-family: Gill Sans;
    font-size: 15px;
    font-weight: 300;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: justified;

}
.charityu {
    font-family: Gill Sans;
    font-size: 16px;
    font-weight: 300;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: justified;

}
</style>
